import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogPostImageInterface } from 'common/types/entities/BlogPostImageInterface'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { BorderStyleEnum } from 'common/types/styleTypes'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogPostImage(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): BlogPostImageInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.BlogPostImage,
      parentId,
      masterBlockId,
    ),
    border: {
      radius: 3,
      width: 1,
      style: BorderStyleEnum.none,
    },
  }
}
